
$( document ).ready(function() {
  $.toasternote = function($type, $msg) {

    $('.toasterNote__text').html($type+"<br><p>"+$msg+"</p>");
    $('.toasterNote__sign').addClass('toasterNote__sign--'+$type)

    $('.toasterNote').first().fadeIn(100, function() {
      $(this).delay(3000).fadeOut(200);
    });
  }
});
